import React from 'react'
import { motion } from 'framer-motion'
import Hero from '../components/Hero'
import Features from '../components/Features'
import About from '../components/About'
import Services from '../components/Services'
import BookingDemo from '../components/BookingDemo'
import Contact from '../components/Contact'
import Testimonials from '../components/Testimonials'
import Team from '../components/Team'
import SEO from '../components/SEO'

const HomePage: React.FC = () => {
  return (
    <>
      {/* Component-based SEO for Homepage */}
      <SEO url="https://logicloud.mx/" type="website" />
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Hero />
        <Features />
        <About />
        <Services />
        <Team />
        <BookingDemo />
        <Contact />
        <Testimonials />
      </motion.div>
    </>
  )
}

export default HomePage

